import { createSelector } from 'reselect';

const routingSelector = ({ routing = {} }) => routing;

export default createSelector(routingSelector, (routing) => routing);



// WEBPACK FOOTER //
// ./app/selectors/routingSelector.js